import React, { useState } from 'react'
import { Col, Form, Modal, Row } from 'react-bootstrap'
import { GreenButton, GreenOutButton } from '../Buttons';

const ComplaintModal = (props) => {
    let dealerId = localStorage.getItem('dealerId');
    const [step, setStep] = useState()

    const [data, setData] = useState({
        dealerId: dealerId,
        claimantName: '',
        claimantMobile: '',
        claimantEmail: '',
        claimantDescription: '',
        dof: '',
    });
    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            handleApiCall()
        }
        setValidated(true);
    };

    const handleApiCall = (event) => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "dealerId": data.dealerId,
            "claimantName": data.claimantName,
            "claimantMobile": data.claimantMobile,
            "claimantEmail": data.claimantEmail,
            "claimantDescription": data.claimantDescription
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(process.env.REACT_APP_URL + "customer/drop-complaint", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "success") {
                    setStep(!step)
                    setData(prevState => ({
                        ...prevState,
                        dof: result.data.createdAt,
                    }))
                }
            })
            .catch(error => console.log('error', error));
    };
    return (
        <React.Fragment>
            <Modal show={props.show} onHide={() => props.closeModal(false)}
                centered
                className="popupwrapper mm_model1 p-0"
            >
                {!step ? <Modal.Header className="pb-0 text-center border-0" closeButton>
                    <h2 className="cpm mb-0 ">Drop a Complaint</h2>
                </Modal.Header>
                    : null
                }
                <Modal.Body className="cp modalWidth px-2 pb-5">
                    {/* <div onClick={() => props.setShow(false)} className="closemark_icon mouse fw-bold">&#x2715;</div> */}
                    {!step ?
                        <Form noValidate validated={validated} onSubmit={handleSubmit}>
                            <Form.Group controlId="validationCustom01">
                                <Form.Label className="cpm mb-0">Dealer Id</Form.Label>
                                <Form.Control
                                    required
                                    type="number"
                                    value={data.dealerId}
                                    onChange={(e) => setData({ ...data, dealerId: e.target.value })}
                                />
                            </Form.Group>

                            <Form.Group controlId="validationCustom01">
                                <Form.Label className="cpm mt-3 mb-0">Customer Name</Form.Label>
                                <Form.Control
                                    required
                                    type="text"
                                    value={data.claimantName}
                                    onChange={(e) => setData({ ...data, claimantName: e.target.value })}
                                />

                            </Form.Group>
                            <Form.Group controlId="validationCustom01">
                                <Form.Label className="cpm mt-3 mb-0">Mobile Number</Form.Label>
                                <Form.Control
                                    required
                                    type="number"
                                    value={data.claimantMobile}
                                    onChange={(e) => setData({ ...data, claimantMobile: e.target.value })}
                                />

                            </Form.Group>
                            <Form.Group controlId="validationCustom01">
                                <Form.Label className="cpm mt-3 mb-0">Email Address</Form.Label>
                                <Form.Control
                                    required
                                    type="email"
                                    value={data.claimantEmail}
                                    onChange={(e) => setData({ ...data, claimantEmail: e.target.value })}
                                />

                            </Form.Group>
                            <Form.Group controlId="validationCustom01">
                                <Form.Label className="cpm mt-3 mb-0">Description of the complaint</Form.Label>
                                <Form.Control
                                    required
                                    rows={4}
                                    as="textarea"
                                    className="text-align-start"
                                    value={data.claimantDescription}
                                    onChange={(e) => setData({ ...data, claimantDescription: e.target.value })}
                                />

                            </Form.Group>
                            <div className="text-center">
                                <GreenButton title="Submit" css="mt-4 mb-2 cpm" />
                            </div>
                        </Form>
                        :

                        <div className="">
                            <div className="text-center">
                                <img src="/assets/icons/tick_mark.png" alt="Green_tick" className="" />
                                <div className="fs_20 cp">Complaint Submitted</div>
                                <p className="fs_14 mt-3 cp">Thank you for contacting us.<br />
                                    We’ll review your complaint soon.</p>
                            </div>
                            <Row className="mx-auto muted_clr cpm fs_14 justify-content-center">
                                <Col xs="6 w-auto" >
                                    <div>Name: </div>
                                    <div>Date of Compalaint: </div>
                                    <div>Mobile Number: </div>
                                    <div>Email Address: </div>
                                </Col>
                                <Col xs="6 w-auto">
                                    <div>{data.claimantName}</div>
                                    <div>{data.dof && (data.dof.slice(8, 10) +"-"+ data.dof.slice(5, 7)+"-"+ data.dof.slice(0, 4))}</div>
                                    <div>+91 - {data.claimantMobile}</div>
                                    <div>{data.claimantEmail}</div>
                                </Col>
                            </Row>
                            <div className="text-center">
                                <GreenOutButton handleSubmit={() => {props.closeModal(false)}} title="Okay" css="my-3 px-5 py-1 fs_16 cpm" />
                            </div>
                        </div>
                    }
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default ComplaintModal
